import * as React from 'react';
import { pathOr } from 'ramda';
import { RadioButtonGroup, UiKitContextProvider } from '@cian/ui-kit';
import { Dropdown } from '../../../packages/Dropdown';
import { DropdownFilterButton } from '../../../packages/DropdownFilterButton';
import { sortRoomsCount } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var RoomsCountSelector = function RoomsCountSelector(props) {
  var value = props.value,
      onValueChange = props.onValueChange,
      className = props.className,
      errorMessage = props.errorMessage,
      values = props.values,
      isLastFilter = props.isLastFilter,
      placeholder = props.placeholder,
      placement = props.placement;
  var selectedLabel = value ? pathOr(placeholder, [value, 'selectedLabel'], values) : placeholder;
  var valuesList = React.useMemo(function () {
    return sortRoomsCount(Object.values(values));
  }, [values]);
  return /*#__PURE__*/_jsx(Dropdown, {
    placement: placement,
    testId: "roomsCount_filter_dropdown",
    master: function master(_ref) {
      var handleToggle = _ref.handleToggle,
          isOpen = _ref.isOpen;
      return /*#__PURE__*/_jsx(DropdownFilterButton, {
        label: selectedLabel,
        handleToggle: handleToggle,
        isLastFilter: isLastFilter,
        isEmpty: !value,
        isActive: isOpen,
        testId: "roomsCount_filter"
      });
    },
    render: function render(_ref2) {
      var handleClose = _ref2.handleClose;
      return /*#__PURE__*/_jsx(UiKitContextProvider, {
        deviceType: "phone",
        useStaticDeviceType: true,
        children: /*#__PURE__*/_jsx(RadioButtonGroup, {
          value: value || undefined,
          options: valuesList,
          onChange: function onChange(_, value) {
            onValueChange(value);
            handleClose();
          },
          spliced: false
        })
      });
    },
    classes: {
      root: className
    },
    errorMessage: errorMessage
  });
};